import { Text } from '@chakra-ui/react';
import { Layout } from 'src/components/Layout';

const Inbox = () => {
  return (
    <Layout width="960px">
      <Text textStyle="headingTitle">Inbox</Text>
    </Layout>
  );
};

export default Inbox;
